<template>
  <v-dialog :value="dialog" max-width="620" persistent>
    <v-card class="up-card">
      <v-form v-on:submit.prevent="upload">
        <div class="up-header">
          <h1>Carga individual de recibo</h1>
        </div>

        <div class="up-body">
          <p class="up-intro">Para recibos sueltos, como una liquidación final o un ajuste.</p>

          <BaseCombobox label="Legajo*" name="legajo" v-model="legajo" :items="legajoItems" item-text="label" item-value="id"
            :loading="loading_legajos" :rules="'required|combobox_required'" :validationErrors="errors" />

          <PayslipPeriodFields v-model="item" />

          <div class="up-label">PDF del recibo*</div>
          <PdfDropZone v-model="file" :error="file_error" />
          <span v-if="file_error" class="red--text">Elegí el PDF del recibo.</span>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">Cargar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { legajoService } from "@/libs/ws/legajoService";
import { PAYSLIP_TYPE_BIWEEKLY, legajoLabel } from "@/constants/payslips";
import PayslipPeriodFields from "./PayslipPeriodFields.vue";
import BaseCombobox from "@/components/BaseCombobox.vue";
import PdfDropZone from "./PdfDropZone.vue";

const defaultItem = () => ({
  type: "final_settlement",
  period_number: null,
  period_month: new Date().getMonth() + 1,
  period_year: new Date().getFullYear(),
  payment_date: null,
});

export default {
  components: { PayslipPeriodFields, BaseCombobox, PdfDropZone },
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      item: defaultItem(),
      legajo: null,
      legajos: [],
      file: null,
      file_error: false,
      loading: false,
      loading_legajos: false,
    };
  },
  computed: {
    // El combobox necesita el texto como propiedad
    legajoItems() {
      return this.legajos.map((legajo) => Object.assign({}, legajo, { label: legajoLabel(legajo) }));
    },
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.item = defaultItem();
      this.legajo = null;
      this.file = null;
      this.file_error = false;
      this.$validator.reset();
      if (this.legajos.length == 0) this.loadLegajos();
    },
    file(value) {
      if (value) this.file_error = false;
    },
  },
  methods: {
    loadLegajos() {
      // Todos los legajos: la liquidacion final puede ser de un legajo ya desvinculado
      this.loading_legajos = true;
      legajoService
        .filter({ status: "all" })
        .then((response) => {
          if (response.status) this.legajos = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading_legajos = false));
    },
    close() {
      this.$emit("updateDialog", false);
    },
    async upload() {
      if (this.loading) return;
      const valid = await this.$validator.validate();
      this.file_error = !this.file;
      if (!valid || this.file_error) return;

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("legajo_id", this.legajo.id);
      formData.append("type", this.item.type);
      formData.append("period_month", this.item.period_month);
      formData.append("period_year", this.item.period_year);
      formData.append("payment_date", this.item.payment_date);
      if (this.item.type == PAYSLIP_TYPE_BIWEEKLY) formData.append("period_number", this.item.period_number);

      this.loading = true;
      payslipService
        .upload(formData)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.close();
            this.$emit("uploaded", response.result);
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al subir el recibo.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.up-card {
  overflow: hidden;
}
.up-header {
  background: #bcd4d8;
  padding: 20px 28px;
}
.up-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #1b4552;
}
.up-body {
  padding: 20px 28px 8px;
  text-align: left;
}
.up-intro {
  margin: 0 0 16px;
  font-size: 14px;
  color: #3d5158;
}
.up-label {
  margin: 4px 0 6px;
  font-weight: 600;
  color: #000;
}
</style>
